'use strict';

module.exports = function() {
  throw new Error(
    'ws does not work in the browser. Browser clients must use the native ' +
      'WebSocket object'
  );
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/ws/browser.js
// module id = 856
// module chunks = 0 1